import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuComponent } from '@progress/kendo-angular-menu';

@Component({
  selector: 'dh-profile-menu',
  templateUrl: './dashboard-profile-menu.component.html',
  styleUrls: ['./dashboard-profile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardProfileMenuComponent {
  @ViewChild('profilePopup') profilePopup: ContextMenuComponent;

  @Input() public background?: string;
  @Input() public image?: string;

  @Output() public logout = new EventEmitter();
  @Output() public openProfileSettings = new EventEmitter();

  public onLogout(): void {
    this.profilePopup.hide();
    this.logout.emit();
  }

  public onOpenProfileSettings(): void {
    this.profilePopup.hide();
    this.openProfileSettings.emit();
  }
}
